import { styled } from "goober";

export const SearchBarRow = styled("div")`
  display: flex;
  align-items: center;
  gap: 2px;
  width: 100%;
  min-width: 0;
  animation: search-bar-fade-in 160ms cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes search-bar-fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const SearchBarInput = styled("input")`
  flex: 1;
  min-width: 0;
  background: transparent;
  border: none;
  outline: none;
  padding: 0 8px 0 0;
  font-family: inherit;
  font-weight: 350;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -1%;
  color: var(--text-primary);

  &::placeholder {
    opacity: 0.3;
  }
`;

export const SearchBarIcon = styled("span")`
  display: inline-flex;
  align-items: center;
  color: var(--text-primary);
  padding: 0 4px 0 8px;
  flex-shrink: 0;
`;

export const SearchBarCount = styled("span")`
  display: flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  background: var(--alpha4);
  border-radius: 38px;
  color: var(--text-secondary);
  font-weight: 450;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0;
  white-space: nowrap;
  flex-shrink: 0;
`;
